import React, { useContext, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { UserTypeContext } from "contexts/UserTypeContext";

import { Button, Spinner } from "@chakra-ui/react";

import PasswordInput from "components/PasswordInput/PasswordInput";

import signin_stock_rb_1_logo from "assets/images/logos/signin_page/signin_stock_rb_1_logo.png";
import signin_stock_rb_2_logo from "assets/images/logos/signin_page/signin_stock_rb_2_logo.png";

import forms_ui_element from "assets/images/ui_elements/forms_ui_element.png";
import useDocumentTitle from "hooks/useDocumentTitle";

import { PostSetPassword } from "services/TokenService";

function OnboardingPassword() {
  useDocumentTitle("Set New Password");

  const { token } = useParams();

  const { userTypes, changeType } = useContext(UserTypeContext);

  const [signInError, setSignInError] = useState("");

  const [loading, setLoading] = useState(false);

  const [password, setPassword] = useState("");
  const [checkPassword, setCheckPassword] = useState("");

  const navigator = useNavigate();

  const [counter, setCounter] = useState(5);
  const [success, setSuccess] = useState(false);

  const validateInput = (password, checkPassword) => {
    if (password === "" || checkPassword === "") {
      setSignInError("Please fill in all fields");

      return false;
    }

    if (password !== checkPassword) {
      setSignInError("Passwords do not match");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateInput(password, checkPassword)) {
      return;
    }

    setLoading(true);

    const formData = new FormData(e.target);

    try {
      const resp = await PostSetPassword(formData, token);
      if (resp.status === 200) {
        // navigator("/login");

        let interval = setInterval(() => {
          setCounter((counter) => counter - 1);
        }, 1000);

        setTimeout(() => {
          clearInterval(interval);
          navigator("/login");
        }, 5000);

        setSuccess(true);
      }
    } catch (error) {
      console.log(error);

      if (error.response) {
        if (error.response.status === 400) {
          setSignInError("Invalid token");
        } else {
          setSignInError("Server error");
        }
      } else {
        setSignInError("Server error");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="sign-in-main-container">
        <div className="signin-left-panel-ts     ">
          <div className=" h-full flex flex-row justify-center  ">
            <div className="flex flex-col justify-center   ">
              <div className=" flex flex-col gap-8    ">
                <img
                  src={signin_stock_rb_1_logo}
                  className=" mx-auto w-16 h-16  "
                  alt="logo"
                />
                <img
                  src={signin_stock_rb_2_logo}
                  className=" mx-auto w-[11.7rem] h-[3.7rem] "
                  alt="logo"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="signin-right-layout-panel z-20   ">
          <div className="    signin-right-container-tc ">
            {success && (
              <div className="  lg:pr-52  ">
                <div className="mb-12">
                  <h1 className="pt-2 pl-2 ">
                    Success! Your new password has been set!
                  </h1>

                  <div className=" mt-5 w-full  flex flex-row justify-center ">
                    <h4>Redirecting to login page in {counter}</h4>
                  </div>

                  <div className=" mt-5 w-full  flex flex-row justify-center ">
                    <Button
                      variant={"link"}
                      onClick={() => navigator("/login")}
                    >
                      Click here if you are not redirected automatically
                    </Button>
                  </div>
                </div>
              </div>
            )}
            {!success && (
              <div className="  lg:pr-52  ">
                <div className="mb-12">
                  <h1 className="pt-2 pl-2 ">Set your new password! </h1>
                </div>

                <form onSubmit={handleSubmit}>
                  {signInError && (
                    <div className="ml-2.5">
                      <p className="text-red-500 font-bold"> {signInError} </p>
                    </div>
                  )}

                  <div className="pt-2  w-[100%] sm:w-[25rem] xl:w-[28rem]">
                    <p className="label"> Password</p>
                    <PasswordInput
                      value={password}
                      onChange={setPassword}
                      isInvalid={signInError}
                      name="password"
                    />
                  </div>

                  <div className="pt-2  w-[100%] sm:w-[25rem] xl:w-[28rem]">
                    <p className="label"> Confirm Password</p>
                    <PasswordInput
                      value={checkPassword}
                      onChange={setCheckPassword}
                      isInvalid={signInError}
                      name="confirm_password"
                    />
                  </div>

                  <div className="mt-8 pl-2  w-[100%] sm:w-[25rem] xl:w-[28rem] ">
                    <Button
                      type="submit"
                      sx={
                        {
                          // width: "24rem",
                        }
                      }
                      isDisabled={loading}
                    >
                      {loading ? (
                        <>
                          <Spinner
                            sx={{ ml: "0.5rem" }}
                            size="lg"
                            color="white"
                          />
                        </>
                      ) : (
                        "Set Password"
                      )}
                    </Button>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
      <img
        src={forms_ui_element}
        className="absolute bottom-0 right-0  h-[30vh]  z-0    "
        alt="forms_ui_element"
      />
    </>
  );
}

export default OnboardingPassword;
